/**
 * This file is part of Iconika.
 *
 * Iconika is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 2 of the License, or
 * any later version.
 *
 * Iconika is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Iconika.  If not, see <https://www.gnu.org/licenses/>.
 */
import { tns } from 'tiny-slider/src/tiny-slider';
import { __ } from '@wordpress/i18n';

{
	document.querySelectorAll('.wp-block-iconika-pharmacy-slider .wp-block-query ul').forEach( el => {
		const slider = tns( {
			container: el,
			items: 3,
			loop: false,
			nav: false,
			controls: true,
			controlsPosition: 'bottom',
			autoWidth: true,
			autoHeight: false,
			freezable: false,
			onInit: function() {
				setTimeout( function() {
					el.classList.add( 'pharmacy-slider-initialized' );
				}, 600 );
			},
			responsive: {
				781:  {
					items: 1,
				},
			},
		} );
		slider.events.on( 'transitionEnd', function() {
			slider.refresh();
		} );
	} );
}
